import { Component, HostListener, OnDestroy, OnInit, inject } from "@angular/core";
import { ActivatedRoute, RouterOutlet } from "@angular/router";
import { KeyboardService } from "common/keyboard.service";
import { MainService } from "core/main.service";

@Component({
	selector: "stages-popup",
	templateUrl: "./popup.component.html",
	imports: [RouterOutlet],
})
export class PopupComponent implements OnInit, OnDestroy {
	private readonly route = inject(ActivatedRoute);
	private readonly keyboardService = inject(KeyboardService);
	private readonly mainService = inject(MainService);

	ngOnInit(): void {
		document.documentElement.style.overflowY = "hidden";
	}

	ngOnDestroy(): void {
		document.documentElement.style.overflowY = "auto";
	}

	@HostListener("document:keydown", ["$event"])
	onKeyDown(event: KeyboardEvent): void {
		if (this.keyboardService.isEscapeKeyPressed(event)) {
			this.close();
		}
	}

	async close(): Promise<void> {
		await this.mainService.closePopup(this.route);
	}
}
